import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function useModels() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/models").then((r) => setM(r.data)).catch(() => {}); }, []);
  return m;
}

export function ModelSelect({ value, onChange, models, testId }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className="w-full h-9 rounded-md bg-slate-900 border border-slate-700 px-3 text-sm" data-testid={testId}>
      {models?.models.map((x) => <option key={x.id} value={x.id}>{x.label} — {x.note}</option>)}
    </select>
  );
}

export function ChapterPicker({ chapters, selected, setSelected, testPrefix }) {
  const all = selected.length === chapters.length;
  return (
    <div className="border border-slate-800 rounded-lg">
      <label className="flex items-center gap-2 px-3 py-2 border-b border-slate-800 text-sm text-amber-300">
        <input type="checkbox" checked={all} onChange={() => setSelected(all ? [] : chapters.map((c) => c.id))} data-testid={`${testPrefix}-select-all`} />Whole manuscript ({chapters.length} sections)
      </label>
      <div className="max-h-56 overflow-y-auto scrollbar-thin p-1">
        {chapters.map((c, i) => (
          <label key={c.id} className="flex items-center gap-2 px-2 py-1.5 text-sm text-slate-300 hover:bg-slate-800/40 rounded">
            <input type="checkbox" checked={selected.includes(c.id)} onChange={() => setSelected(selected.includes(c.id) ? selected.filter((x) => x !== c.id) : [...selected, c.id])} data-testid={`${testPrefix}-chapter-${i}`} />
            <span className="truncate flex-1">{c.title}</span><span className="text-[11px] font-mono text-slate-500">{c.word_count} w</span>
          </label>
        ))}
      </div>
    </div>
  );
}
